import React, { FC, useMemo } from "react";
import classNames from "classnames";
import { Body } from "features/DocumentModal/Body";
import { useAtom } from "jotai/index";
import {
  DocumentsData,
  DocumentsOperations,
} from "constant-data/documentsData";
import moment from "moment";
import Footer from "features/DocumentModal/Footer";

import { BaseLayout } from "components/BaseLayout/BaseLayout";
import { ModalHeader } from "components/Modal/AppModal";

import {
  openedDocumentAtom,
  selectedDocumentTypeAtom,
} from "../../atoms/documentsAtom";
import { TDocumentModalData } from "../../types/documents";
import useDocuments from "../../hooks/useDocuments";

import { ComponentRender } from "./ComponentRender";
import styles from "./styles.module.scss";

interface DocumentModalProps {}

export const DocumentModal: FC<DocumentModalProps> = ({}): JSX.Element => {
  const [openedDocument, setOpenedDocument] = useAtom(openedDocumentAtom);
  const [selectedDocumentType] = useAtom(selectedDocumentTypeAtom);
  const { closeDocumentModal } = useDocuments();

  const modalTitle = useMemo(
    () =>
      openedDocument
        ? `Документ ${DocumentsOperations.find(
            (i) => +i.id === openedDocument.type
          )?.name?.toLowerCase()} товаров №${openedDocument.docid} от ${moment(
            openedDocument.time
          ).format("DD.MM.YYYY HH:mm:ss")}`
        : "",
    [openedDocument]
  );

  const componentsArr = useMemo(() => {
    return openedDocument?.type
      ? DocumentsData[openedDocument.type.toString()].modalData
      : [];
  }, [openedDocument]);

  if (!componentsArr || !selectedDocumentType) return <></>;

  return (
    <BaseLayout
      className={classNames("ml-2 mt-3 mb-3 px-8" as any, styles.container)}
      header={<ModalHeader title={modalTitle} onClose={closeDocumentModal} />}
      footer={<Footer />}
    >
      <ComponentRender elements={componentsArr as TDocumentModalData[]} />
      <Body
        columns={DocumentsData[selectedDocumentType.id]?.modalColumns}
        bottomRow={DocumentsData[selectedDocumentType.id]?.modalBottomRow}
      />
    </BaseLayout>
  );
};

{
  /*<Accordion
        withIcon={false}
        handleCollapse={() =>
          setAdditionallyCollapse((prevState) => !prevState)
        }
        collapsed={!additionallyCollapse}
        iconClassNames="mr-3.5"
        parent={
          <AccordionParent
            name="Дополнительно"
            collapsed={!additionallyCollapse}
            iconClassNames="mr-3.5"
          />
        }
      >
        <DocItemModal5 elements={additionallyArr} />
      </Accordion>*/
}

/*
*  const additionallyArr: ComponentTypeProps[] = [
    {
      name: "№ документа",
      type: "input",
    },
    {
      name: "На основании чека",
      type: "input",
    },
    {
      name: "Ответственный",
      type: "input",
    },
    {
      name: "Создан в",
      type: "select",
    },
    {
      name: "Долг компании:",
      optionData: "356 ₽",
      type: "textPointer",
    },
    {
      name: "Оплат по документу:",
      optionData: "482 ₽",
      type: "textPointer",
    },
    {
      name: "Клиент должен:",
      optionData: "346 ₽",
      type: "textPointer",
    },
  ];*/
